import { formatArgentinaDate } from './dateUtils';

/**
 * Format a number as currency in ARS (Argentine Peso)
 */
export const formatCurrency = (amount: number): string => {
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

/**
 * Format a number as currency for CSV export (using commas instead of points)
 */
export const formatCurrencyForCSV = (amount: number): string => {
  return amount.toFixed(2).replace('.', ',');
};

/**
 * Format a date string to localized format (DD/MM/YYYY)
 */
export const formatDate = (dateString: string): string => {
  return formatArgentinaDate(dateString);
};